import type { WidgetLayout } from '@proadv/types';

/**
 * Layout default da pagina de clientes. Grid 4 colunas x 3 linhas.
 *
 * Linha 1 (y=0): 4 cards 1x1 — KPIs e aniversariantes.
 * Linha 2 (y=1): top_sources 2x2, age_ranges 1x2, top_professions 1x2.
 *
 * Total: 4 + 2*2 + 1*2 + 1*2 = 12 slots — exatamente o grid 4x3.
 */
export const CLIENTS_DEFAULT_LAYOUT: WidgetLayout[] = [
  { widgetId: 'summary_total', x: 0, y: 0, w: 1, h: 1 },
  { widgetId: 'summary_with_process', x: 1, y: 0, w: 1, h: 1 },
  { widgetId: 'summary_without_process', x: 2, y: 0, w: 1, h: 1 },
  { widgetId: 'birthdays', x: 3, y: 0, w: 1, h: 1 },
  { widgetId: 'top_sources', x: 0, y: 1, w: 2, h: 2 },
  { widgetId: 'age_ranges', x: 2, y: 1, w: 1, h: 2 },
  { widgetId: 'top_professions', x: 3, y: 1, w: 1, h: 2 },
];
